export const columnList = [
    'no',
    'fanpage',
    'formName',
]

export const ERROR_RESPONSE_TEXT = 'Failed to load instant forms';

export const ERROR_CREATE_TEXT = 'Failed to create';
export const ERROR_UPDATE_TEXT = 'Failed to update';

export const SUCCESS_CREATE_TEXT = 'Created';
export const SUCCESS_UPDATE_TEXT = 'Updated';

export const INIT_VALUES = {
    additional_info: [],
    fanpage: '',
    form_id: '',
    form_name: '',
    product: '',
    market: '',
    lang_field_name: '',
    price: '',
    default_product_variant: undefined,
    is_active: false,
}